  (function(doc, win) {
    var _html = document.getElementsByTagName("html")[0];
        _html.style.fontSize = _html.clientWidth / 10 + "px";
		var docEl = doc.documentElement,
		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',//移动端事件
		recalc = function() {
      var clientWidth = docEl.clientWidth;
      // console.log(clientWidth);
      if (!clientWidth) return;
      if (clientWidth >= 440) {
      docEl.style.fontSize = '44px';

      } //else {
  //		docEl.style.fontSize = (clientWidth / 10) + 'px';
  //		}
    };
		// if (!doc.addEventListener) return;
		addEvent(win,resizeEvt, recalc, false);
		addEvent(doc,'DOMContentLoaded', recalc, false);
		}(document, window));

function addEvent (el,event,fn,bool) {
	if(el.addEventListener){
		el.addEventListener(event,fn,bool);
	}else if(el.attachEvent){
		el.attachEvent('on'+event,function(){
			fn.call(el);
		});
	}else{
		el['on' + event ] = fn;
	}
}



//////////////////
// WEBPACK FOOTER
// ./static/js/mobile_terminal-width.js
// module id = rTyD
// module chunks = 0